const ProjectVerbs = ['cake', 'cakeConfig', 'mint', 'transfer', 'userPost'];

export default ProjectVerbs;
